new Swiper('[js-about-block]', {
    loop: false,
    slidesPerView: 1.2,
    paginationClickable: true,
    navigation: {
        nextEl: ".click-arrow-right",
        prevEl: ".click-arrow-left",
      },
    breakpoints: {
        768: {
            spaceBetween: 38,
        },
        360: {
            spaceBetween: 20,
        }
    },
});

new Swiper("[js-cart-slider]", {
    slidesPerView: 3,
    spaceBetween: 64,
    pagination: {
    el: ".swiper-pagination",
    dynamicBullets: false,
    clickable: true
  },
  breakpoints: {
    1280: {
    slidesPerView: 3,
    spaceBetween: 64,
    },
    991: {
    spaceBetween: 30,
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 30,

    },
    360: {
        slidesPerView: 1.2,
        spaceBetween: 16,
    }
    },
});


// START: Verbesserte Logik für den Schließen-Button der mobilen Suche
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom Search-Skript wird geladen...');

  const searchDrawer = document.querySelector('#search-drawer');
  if (!searchDrawer) {
    console.error('Fehler: Such-Schublade #search-drawer wurde nicht gefunden.');
    return;
  }

  const closeButton = searchDrawer.querySelector('.drawer__close-button');
  const searchInput = searchDrawer.querySelector('.predictive-search__input');
  const overlay = searchDrawer.querySelector('.drawer__overlay'); // Das Overlay zum Schließen

  if (!closeButton || !searchInput || !overlay) {
    console.error('Fehler: Eines der benötigten Elemente (Button, Input oder Overlay) fehlt.');
    return;
  }

  console.log('Alle Elemente für die Suche gefunden. Event Listener wird hinzugefügt.');

  closeButton.addEventListener('click', function(event) {
    // Verhindere IMMER die Standard-Aktion, um die volle Kontrolle zu haben.
    event.preventDefault();
    event.stopPropagation();

    console.log('Schließen-Button geklickt.');

    // Prüfen, ob das Suchfeld Text enthält
    if (searchInput.value.trim() !== '') {
      console.log('Suchfeld hat Text -> wird geleert.');
      searchInput.value = '';
      searchInput.focus();
      // Wichtig für Predictive-Search, um Ergebnisse zu leeren
      searchInput.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    } else {
      console.log('Suchfeld ist leer -> Schublade wird geschlossen durch Klick auf Overlay.');
      // Simuliere einen Klick auf das Overlay, um die Schublade zu schließen.
      // Dies ist robuster als der direkte Aufruf einer .close() Funktion.
      overlay.click();
    }
  });
});
// ENDE: Verbesserte Logik für den Schließen-Button